import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import type { LLCAmendmentsModalComponent } from '../amendments.component';

@Component({
	selector: 'app-td-acknowledge-modal',
	templateUrl: './td-acknowledge-modal.component.html',
	standalone: false,
})
export class TdAcknowledgeModalComponent {
	constructor(public dialogRef: MatDialogRef<LLCAmendmentsModalComponent>) {}

	acknowledge() {
		this.dialogRef.close();
	}
}
